import React from 'react';

export const ErrorPage = (props) => {
    return (
        <p className='error' align='center'>{props.Message ? props.Message : 'You are not authorized to do this action'}</p>
    )
}

